import apiRoutes from '../../../setup/consts/apiRoutes';
import { makeMutationFn } from '../../../utils/reactQuery';
import { VerifyRequestBody, VerifyResponse } from './types';

export const VERIFY_MUTATION_FN = makeMutationFn<
  VerifyRequestBody,
  VerifyResponse
>(apiRoutes.VERIFY);
